/* GTM ecom events for Shopify — drop-in */
(function () {
  var CURRENCY = (window.Shopify && Shopify.currency && Shopify.currency.active) ||
                 (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.currency) || 'USD';
  function money(n){ return Math.round(Number(n||0))/100; }
  function pushDL(obj){ window.dataLayer = window.dataLayer || []; window.dataLayer.push(obj); }

  // ----- ADD TO CART (form submit)
  document.addEventListener('submit', function(e){
    var form = e.target && e.target.closest('form[action="/cart/add"]');
    if(!form) return;
    try{
      var fd = new FormData(form);
      var qty = parseInt(fd.get('quantity') || '1', 10);
      var variantId = fd.get('id') || fd.get('items[0][id]');
      var meta = (window.ShopifyAnalytics && ShopifyAnalytics.meta) || {};
      var p = meta.product || {};
      var v = (p.variants || []).find(function(v){ return String(v.id) === String(variantId); }) || {};
      pushDL({ event:'add_to_cart', ecommerce:{ currency:CURRENCY, items:[{
        item_id: variantId || (v && v.id),
        item_name: (p && (p.name||p.title)) || document.querySelector('h1')?.textContent?.trim(),
        item_brand: p && p.vendor,
        item_variant: (v && (v.public_title||v.title)) || undefined,
        price: money(v && v.price),
        quantity: qty
      }]}});
    }catch(_){}
  }, true);

  // ----- ADD TO CART (AJAX /cart/add)
  (function(){
    function pushFromAddJson(json){
      if(!json || !json.id) return;
      pushDL({ event:'add_to_cart', ecommerce:{ currency:CURRENCY, items:[{
        item_id: json.id, item_name: json.product_title, item_brand: json.vendor,
        item_variant: json.variant_title, price: money(json.final_price||json.price),
        quantity: json.quantity || 1
      }]}});
    }
    var _fetch = window.fetch;
    window.fetch = function(input, init){
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var isAdd = url.indexOf('/cart/add') > -1;
      return _fetch.apply(this, arguments).then(function(res){
        if(isAdd){ try{ res.clone().json().then(pushFromAddJson).catch(function(){}); }catch(_){ } }
        return res;
      });
    };
    var _open = XMLHttpRequest.prototype.open, _send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function(method, url){ this.__isAdd = (url||'').indexOf('/cart/add')>-1; return _open.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function(){ this.addEventListener('load', function(){ if(this.__isAdd){ try{ pushFromAddJson(JSON.parse(this.responseText)); }catch(_){ } } }); return _send.apply(this, arguments); };
  })();

  // ----- VIEW CART (cart page)
  function onCartPage(){ return /^\/cart(?:\/|$|\?)/.test(location.pathname); }
  if(onCartPage()){
    try{
      fetch('/cart.js', {credentials:'same-origin'}).then(function(r){ return r.json(); }).then(function(cart){
        if(!cart || !cart.items || !cart.items.length) return;
        pushDL({ event:'view_cart', ecommerce:{ currency:CURRENCY, value: money(cart.total_price),
          items: cart.items.map(function(it){ return {
            item_id: String(it.sku || it.variant_id || it.id),
            item_name: it.product_title, item_brand: it.vendor, item_variant: it.variant_title,
            price: money(it.final_price || it.price), quantity: it.quantity
          }; })
        }});
      }).catch(function(){});
    }catch(_){}
  }

  // ----- BEGIN CHECKOUT (when user clicks checkout)
  document.addEventListener('click', function(e){
    var el = e.target && e.target.closest('a, button, input[type="submit"]'); if(!el) return;
    var href = (el.getAttribute && el.getAttribute('href')) || '';
    var isCheckout = (href && href.indexOf('/checkout')>-1) || el.name === 'checkout';
    if(!isCheckout) return;
    pushDL({ event:'begin_checkout' });
  }, true);
})();
